import React from 'react';
import config from '~/config';
import PropTypes from 'prop-types';

const MetaTitle = ({ children }) => {
  const title = Array.isArray(children) ? children.join('') : children;
  return <title>{title + ' | ' + config.APP_TITLE}</title>;
}

MetaTitle.propTypes = {
  children: PropTypes.any,
}

export default MetaTitle;
